const permission = {
    permissionDictionary: {
        /* 
            設定權限，元件name將比對Array(value)內字串，得到與後台對應權限名稱(key)
        */
        'Permissions1': ['查詢', 'Query'],
        'Permissions2': ['新增', 'Insert'],
        'Permissions3': ['修改', 'Update'],
        'Permissions4': ['刪除', 'Delete'],
        'Permissions5': ['細增', 'InsertList'],
        'Permissions6': ['細修', 'UpdateList'],
        'Permissions7': ['細刪', 'DeleteList'],
        'Permissions8': ['瀏覽', 'Preview'],
        'Permissions9': ['列印', 'Print'],
        'Permissions10': ['預留1', 'Reserve1'],
        'Permissions11': ['預留2', 'Reserve2'],
        'Permissions12': ['預留3', 'Reserve3'],
        'Permissions13': ['預留4', 'Reserve4'],
        'Permissions14': ['預留5', 'Reserve5'],
        'Permissions15': ['預留6', 'Reserve6']
    },

    checkPermissionByName(name){
        let searchDictionarySource = this.permissionDictionary
        
        for(let key in searchDictionarySource){
            if(searchDictionarySource[key].find(e => 
                    {
                        return (name.toLowerCase()).includes(e.toLowerCase())
                    }
                )){
                return key
            }
        }

        return null
    }
}

export default permission